import React from 'react'

import { Box } from '../Box/Box'
import { Stack } from '../Stack/Stack'
import { Inline } from '../Inline/Inline'

export interface ButtonGroupProps {
  children: React.ReactNode[]
  stack?: boolean
  align?: 'start' | 'center' | 'end' | 'between' | 'evenly'
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({ stack = false, align, ...props }) => {
  return (
    <Box {...props}>
      {stack ? (
        <Stack space="m">{props.children}</Stack>
      ) : (
        <Inline alignX={align} space="m">
          {props.children}
        </Inline>
      )}
    </Box>
  )
}
